import { Reducer } from 'redux';

import { WritingAssistantGenerateChatContentAction } from '../../domains/writingAssistant/actions.types';

import { WritingAssistant } from './types';

const initialState: WritingAssistant = {
  status: 'notRequested',
  chatHistory: [],
  currentContext: '',
};

export type WritingAssistantAction = WritingAssistantGenerateChatContentAction;

const reducer: Reducer<WritingAssistant, WritingAssistantAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'WRITING_ASSISTANT_GENERATE_CHAT_CONTENT.PENDING':
      return {
        ...state,
        status: 'pending',
        error: null,
        chatHistory: [
          ...state.chatHistory,
          {
            __typename: 'ViewerChatMessage',
            chatText: action.payload.chatText,
          },
        ],
      };
    case 'WRITING_ASSISTANT_GENERATE_CHAT_CONTENT.FULFILLED':
      return {
        ...state,
        status: 'fulfilled',
        error: null,
        chatHistory: [...state.chatHistory, action.payload],
        currentContext: action.payload.context,
      };
    case 'WRITING_ASSISTANT_GENERATE_CHAT_CONTENT.REJECTED':
      return {
        ...state,
        status: 'rejected',
        error: action.payload.error,
      };
    case 'WRITING_ASSISTANT.CLEAR':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
